/*
 * Lib Module Icon
 */

class Icon extends LibModule {

    /**
     *
     * @param icon
     * @param options
     * @returns {*}
     */
    i(icon, options) {

        if (!options) {
            options = {};
        }

        // Get classes
        let iconClasses = Lib.Hash.get(options, 'class', []);

        // Normalize it into an array
        if (typeof iconClasses === 'string') {
            iconClasses = iconClasses.split(' ');
        }

        // Mandatory classes
        iconClasses.push('is-icon');
        iconClasses.push('material-icons');

        // Size classes
        if (Lib.Hash.get(options, 'xs')) {
            iconClasses.push('m-xs');
            delete options['xs'];
        }

        if (Lib.Hash.get(options, 'sm')) {
            iconClasses.push('m-sm');
            delete options['sm'];
        }

        if (Lib.Hash.get(options, 'lg')) {
            iconClasses.push('m-lg');
            delete options['lg'];
        }

        if (Lib.Hash.get(options, 'xl')) {
            iconClasses.push('m-xl');
            delete options['xl'];
        }

        // Added fw to classes
        if (Lib.Hash.get(options, 'fw')) {
            iconClasses.push('m-fw');
            delete options['fw'];
        }

        // Add anti-alias to classes
        if (Lib.Hash.get(options, 'anti-alias')) {
            iconClasses.push('m-anti-alias');
            delete options['anti-alias'];
        }

        // Normalize the icon html, so you can pass m-check_box and check_box to this function
        if (icon.substr(0, 2) === 'm-') {
            icon = icon.substr(2);
        }

        // Filter duplicates
        iconClasses = Lib.Util.arrayUnique(iconClasses);

        // Set classes back
        options['class'] = iconClasses.join(' ');

        // Build it
        return Lib.Element.spawn('i', options, icon);
    }

    /**
     *
     * @param el
     * @param newIcon
     * @returns {*}
     */
    swap(el, newIcon) {
        return el.html(newIcon);
    }
}

Lib.Icon = new Icon;
